import React from 'react'
import styles from "./BarTop.module.scss"

const BarTop = () => {
    return (
        <header className={styles.barTop}>
            <p className="m-0 p-1">
                <strong>VASLOLA</strong> es la plataforma oficial de venta primaria de entradas, nos encargamos de que todo suceda.
            </p>
        </header>
    )
}

export default BarTop